import React from "react";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";

export default function ProButton({ children, ...props }) {
  return (
    <Button variant="contained" color="primary" {...props}>
      {children}
    </Button>
  );
}

ProButton.propTypes = {
  children: PropTypes.node.isRequired
};